import { isValidPhoneNumber } from 'react-phone-number-input';

const Phone = {
  isValidPhoneNumber: (phoneNumber: string): boolean => {
    try {
      if (typeof phoneNumber !== 'string') {
        return false;
      }
      return isValidPhoneNumber(phoneNumber);
    } catch (error) {
      return false;
    }
  },
};

export default Phone;
